React = require 'react'
Logo = require './Logo.cjsx'

Header = React.createClass
  propTypes:
    title: React.PropTypes.string

  render: ->
    React.createElement("header", {"className": 'py2'},
      React.createElement(Logo, null)
    )

module.exports = Header




/** WEBPACK FOOTER **
 ** ./~/cjsx-loader!./app/components/Header.cjsx
 **/